import { RootState } from '..';
import { getNestedField } from '../utils';

export const getPrint =
  (state: RootState) =>
  <T extends FlattenKeys<PrintState>>(field: T) =>
    getNestedField(state.print, field);

const printGetters = (state: RootState) => ({
  getPrint: getPrint(state),
});

export default printGetters;
